import { observer } from 'mobx-react-lite';
import { Button } from '../../../buttons/button';
import { PopupStore } from '../../popup.store';

export const PaymentSuccess = observer<{ popupStore: PopupStore; styles: { [key: string]: string } }>(({ popupStore, styles }) => {
  return (
    <>
      <h4 className="cust-my-4">
        <i className="text-warning icon-tick text-success  h1 cust-pr-1" />
        Payment is successful
      </h4>

      <Button meta={{ name: 'close', title: 'Close' }} onClick={() => popupStore.changePaymentInProgress(false)} />
    </>
  );
});